import {
  PromotionUpdateRequestType,
  PromotionUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const usePromotionUpdate = (promotionId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: PromotionUpdateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `promotions/${promotionId}`,
        data,
      }).then(
        (data) => apiV2AssertResponse(data).data as PromotionUpdateResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.Promotions],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.Promotions, promotionId],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.PriceTiers],
      });
    },
  });
};
